

export function formatProfit(column, record) {
  let objKey = column.key == "cps分成" ? 'amount' : 'count'
  return record?.profit_stats && record?.profit_stats[column.key] && record?.profit_stats[column.key][objKey] ? record?.profit_stats[column.key][objKey] : 0
}
